import { useEffect, useState } from 'react';

export function useIsSmallScreen(maxWidth: number = 900): boolean {
  const [small, setSmall] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const listener = () => setSmall(mq.matches);
    listener();
    mq.addEventListener('change', listener);
    return () => mq.removeEventListener('change', listener);
  }, [maxWidth]);
  return small;
}
